import { MatDialog } from '@angular/material';
import { VideoInfoModalComponent } from './video-info-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
var VideoInfoModalService = /** @class */ (function () {
    function VideoInfoModalService(matDialog) {
        this.matDialog = matDialog;
    }
    VideoInfoModalService.prototype.open = function (_a) {
        var title = _a.title, description = _a.description, callToAction = _a.callToAction, videoId = _a.videoId, footer = _a.footer;
        return this.matDialog.open(VideoInfoModalComponent, {
            data: { title: title, description: description, callToAction: callToAction, videoId: videoId, footer: footer }
        }).afterClosed()
            .toPromise();
    };
    VideoInfoModalService.prototype.close = function () {
        this.matDialog.closeAll();
    };
    VideoInfoModalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VideoInfoModalService_Factory() { return new VideoInfoModalService(i0.ɵɵinject(i1.MatDialog)); }, token: VideoInfoModalService, providedIn: "root" });
    return VideoInfoModalService;
}());
export { VideoInfoModalService };
